import React from "react";
import CommonRow from "../common-row";

const SliderFocusedCard = props => {
  return <CommonRow {...props} />;
};

export default SliderFocusedCard;
